import { normalizeFontFamilyName } from '../normalize-font-family-name';
import { getFontFallback } from './get-font-fallback';
import { modifyFontFamily } from './modify-font-family';
export const injectFontFallbacks = modifyFontFamily((fontFamily) => {
    const nomalizedFontFamilyName = normalizeFontFamilyName(fontFamily);
    return [fontFamily, getFontFallback(nomalizedFontFamilyName)];
});
//# sourceMappingURL=inject-font-fallbacks.js.map